export default __webpack_public_path__ + "static/straight-cup-light-green-4f598a1c88b2cf8b6b1a0655f2b35595.png";